// @ts-strict-ignore
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Dictionary } from 'lodash';
import { useAppDispatch, useAppSelector } from '../../redux';
import { SubjectSummaryReport, SummaryReportLeafData } from './subjectSummaryReport';
import { SubjectTree } from '../../components/SubjectTree';
import { getClassState, getStudentUsage } from '../../redux/actions/class';
import { ModuleEventWithUserClass } from '../../../types/routes/module';
import { Class as ClassWithStudents } from '../../../types/routes/class';
import { StatsWrapperClassroom } from '../../components/StatsWrapperClassroom';
import Summary from '../../assets/icons/summary.svg';
import { Spinner } from '../../components/Spinner';
import { Alert, ExtraAlertText } from '../../components/Alert';

interface Props {
  currentClass: ClassWithStudents;
  eventsByStudent: Dictionary<ModuleEventWithUserClass[]>;
  lastEventByStudent: Dictionary<ModuleEventWithUserClass>;
}

export const ClassSummaryPage: React.FC = () => {
  const params = useParams();
  return (
    <StatsWrapperClassroom
      match={params}
      ChildComponent={ClassSummaryChild}
      pageTitle="Class Summary Report"
      classOnlyData={true}
      Icon={Summary}
    />
  );
};

const ClassSummaryChild = ({ currentClass, eventsByStudent, lastEventByStudent }: Props) => {
  const dispatch = useAppDispatch();
  const modules = useAppSelector((state) => state.module.definitions);
  const studentUsage = useAppSelector((state) => state.class.studentUsage);
  const fetchingStudentUsage = useAppSelector((state) => state.class.fetchingStudentUsage);
  const hasStudentUsageError = useAppSelector((state) => state.class.hasStudentUsageError);
  const studentUsageErrorMessage = useAppSelector((state) => state.class.studentUsageErrorMessage);

  useEffect(() => {
    dispatch(getStudentUsage(currentClass.id));
    // BvdS:  we could later add a filter for the desired variable.
    dispatch(getClassState({ classId: currentClass.id }));
  }, [currentClass]);

  const leafDataModuleList = new Set<string>();
  for (const s of Object.values(studentUsage.students)) {
    for (const moduleId of Object.keys(s.modules)) {
      leafDataModuleList.add(moduleId);
    }
  }

  if (hasStudentUsageError) {
    return (
      <Alert severity="error" title="Error Loading Student Usage Data">
        {studentUsageErrorMessage && <ExtraAlertText>Error message: {studentUsageErrorMessage}</ExtraAlertText>}
      </Alert>
    );
  }
  if (!currentClass || fetchingStudentUsage || Object.keys(modules).length == 0) {
    return <Spinner label="Fetching data ..." center />;
  } else {
    return (
      <SubjectTree<SummaryReportLeafData>
        leafData={{ eventsByStudent, lastEventByStudent }}
        leafDataModuleList={leafDataModuleList}
        LeafComponent={SubjectSummaryReport}
      />
    );
  }
};
